import { FC, useEffect, useState } from 'react';

import { Box, OutlinedInput, Select } from '@mui/material';
import { SelectChangeEvent } from '@mui/material-next';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';

import PrimaryButton from 'components/Common/PrimaryButton';
import BasicModal from 'components/Common/BasicModal';
import { useTranslation } from 'react-i18next';
import { Storage } from 'storage';
import { LanguagesType } from 'components/DefaultSettings/types';
import { getLanguages } from 'api/queries/languages';

interface SystemLanguageModalType {
    open: boolean;
    onClose: () => void;
}

const SystemLanguageModal: FC<SystemLanguageModalType> = ({ open, onClose }) => {
    const { i18n, t } = useTranslation();
    const [interfaceLanguage, setInterfaceLanguage] = useState<string>('');
    const [interfaceLanguages, setInterfaceLanguages] = useState<LanguagesType[]>([]);

    useEffect(() => {
        getDefaultInterfaceLanguage();
        getLanguages(setInterfaceLanguages);
    }, []);

    const getDefaultInterfaceLanguage = () => {
        const language = Storage.getItem('i18nextLng_custom');
        if (language) {
            return setInterfaceLanguage(language);
        }
        setInterfaceLanguage('en');
    };

    const handleInterfaceSelect = (event: SelectChangeEvent) => {
        const value = event.target.value;
        setInterfaceLanguage(value);
    };

    const onSubmit = () => {
        i18n.changeLanguage(interfaceLanguage);
        Storage.setItem('i18nextLng_custom', interfaceLanguage);
        onClose();
    };

    return (
        <BasicModal open={open} onClose={onClose}>
            <Box className="language-modal">
                <Box>
                    <FormControl className="language-modal-select">
                        <label id="job-language-label">
                            {t('web_app.home.settings.interface')}
                        </label>
                        <Select
                            labelId="job-language-label"
                            value={interfaceLanguage}
                            onChange={handleInterfaceSelect}
                            label={t('web_app.home.settings.interface')}
                            input={<OutlinedInput />}
                        >
                            {interfaceLanguages
                                .sort((a, b) => a.title.localeCompare(b.title))
                                .map((item) => (
                                    <MenuItem key={item.key} value={item.key}>
                                        {item.title}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box className="language-modal-btn">
                    <PrimaryButton onClick={onSubmit} text={t('web_app.save_btn')}></PrimaryButton>
                </Box>
            </Box>
        </BasicModal>
    );
};

export default SystemLanguageModal;
